import { reduxStore } from '@consigli/hooks';
import { AuthProvider } from '@consigli/oauth';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { router } from './router';

import type { FC } from 'react';

import 'react-toastify/dist/ReactToastify.css';

export const App: FC = () => (
  <ReduxProvider store={reduxStore}>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </ReduxProvider>
);
